// extracted by mini-css-extract-plugin
export default {"container":"status_container__M+Bfv","tags":"status_tags__0Kb++","tag":"status_tag__viFUm","select":"status_select__DToiR"};